"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgCar = function SvgCar(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M864 560c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48 48 21.5 48 48zm-656-48c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm816 32v160c0 19.2-12.8 32-32 32h-80v96c0 19.2-12.8 32-32 32H752c-19.2 0-32-12.8-32-32v-96H304v96c0 19.2-12.8 32-32 32H144c-19.2 0-32-12.8-32-32v-96H32c-19.2 0-32-12.8-32-32V544c0-67.2 41.6-124.8 102.4-150.4L160 384l16-16 35.2-105.6C230.4 198.4 284.8 160 352 160h320c67.2 0 121.6 38.4 140.8 99.2L848 364.8l16 19.2 57.6 9.6C982.4 419.2 1024 476.8 1024 544zM236.8 384h553.6l-35.2-102.4C742.4 246.4 710.4 224 672 224h-96c0 19.2-12.8 32-32 32h-64c-19.2 0-32-12.8-32-32h-96c-38.4 0-70.4 22.4-83.2 57.6l-32 102.4zm3.2 352h-64v64h64v-64zm608 0h-64v64h64v-64zm112-192c0-54.4-41.6-96-96-96H160c-54.4 0-96 41.6-96 96v128h896V544z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgCar, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;